// src/components/store/sections/testimonials/TestimonialV30BentoreviewsIndigoPulse.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV30BentoreviewsIndigoPulse(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={30}
      archKey="bento_reviews"
      archLabel="Bento Review Matrix"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
